import React, { useState, useEffect } from "react";
import { SearchParameters } from "../../model/SearchParameters";

const FilterComponentMulti = ({
  allFilters,
  componentName,
  componentTypeKey,
  selectedFilter,
  setSelectedFilter,
  lastSelectedFilter,
  selectedGroupType,
}: {
  allFilters: SearchFilterItem[];
  componentName: string;
  componentTypeKey: keyof SearchParameters;
  lastSelectedFilter: string | null;
  selectedFilter: string[] | null;
  setSelectedFilter: (
    type: keyof SearchParameters,
    value: string[] | string,
    brand: string | null,
  ) => void;
  selectedGroupType: string | null;
}) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  const setBrandFilter = (brand: string | null) => {
    const options: string[] = [];
    setSelectedOptions(options);
    setSelectedFilter(componentTypeKey, options, brand);
  };

  const groupFiltersByCategory = (allFilters: SearchFilterItem[]) => {
    return allFilters.reduce(
      (acc, filter) => {
        if (!acc[filter.brand]) {
          acc[filter.brand] = [];
        }
        acc[filter.brand].push(filter);
        return acc;
      },
      {} as Record<string, SearchFilterItem[]>,
    );
  };

  const groupedFilters = groupFiltersByCategory(allFilters);

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = e.target.value as string;
    setBrandFilter(selectedId);
  };

  const handleOptionChange = (option: string) => {
    let updateOptions: string[] = selectedOptions.includes(option)
      ? selectedOptions.filter((o) => o !== option)
      : [...selectedOptions, option];
    setSelectedOptions(updateOptions);
    setSelectedFilter(componentTypeKey, updateOptions, null);
  };

  useEffect(() => {
    setSelectedOptions(selectedFilter || []);
  }, [selectedFilter]);

  return (
    <div className={`field mt-4`}>
      <div className="control multi-filter">
        <div className="is-fullwidth flex flex-wrap">
          <div className="is-align-content-space-evenly">
            <label className="label">{componentName}</label>
          </div>
          <div className="select ml-10">
            <select
              value={selectedGroupType || ""}
              onChange={handleSelectChange}
            >
              <option value="">Todos</option>
              {Object.entries(groupedFilters).map(([type, filters]) =>
                filters
                  .filter((filter) => filter.brand === type && !filter.name)
                  .map(
                    (filter, index) =>
                      filter.brand.trim() !== "" && (
                        <option key={index} value={filter.brand}>
                          {filter.brand}
                        </option>
                      ),
                  ),
              )}
            </select>
          </div>
        </div>
        <div className="field m-3">
          <div className="checkboxes grid">
            {Object.entries(groupedFilters).flatMap(([type, filters]) =>
              filters.map((option, index) => {
                if (
                  lastSelectedFilter != null &&
                  ((lastSelectedFilter != componentTypeKey &&
                    option.count_filter_compounds === 0 &&
                    option.brand !== selectedGroupType) ||
                    (lastSelectedFilter == componentTypeKey &&
                      option.count_skipped_compounds === 0)) &&
                  !selectedOptions.includes(option.name)
                ) {
                  return null;
                }
                return (
                  option.name && (
                    <label
                      key={
                        option.component_type_key +
                        option.brand +
                        option.name +
                        index
                      }
                      className={`checkbox is-block ${
                        (lastSelectedFilter != null &&
                          lastSelectedFilter != componentTypeKey &&
                          option.count_filter_compounds === 0) ||
                        ((selectedGroupType ?? "") != "" &&
                          selectedGroupType !== option.brand)
                          ? "opacity-50"
                          : ""
                      }`}
                    >
                      <input
                        type="checkbox"
                        value={option.name}
                        name={option.name}
                        disabled={
                          (selectedGroupType ?? "") != "" &&
                          selectedGroupType !== option.brand
                        }
                        checked={selectedOptions.includes(option.name)}
                        onChange={() => handleOptionChange(option.name)}
                      />
                      <span className="p-2 y-2">{option.name}</span>{" "}
                      <span className="float-right text-xs">
                        {lastSelectedFilter != null &&
                        lastSelectedFilter != componentTypeKey
                          ? option.count_filter_compounds
                          : option.count_compounds}
                      </span>
                    </label>
                  )
                );
              }),
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterComponentMulti;
